import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import resize from '@/mixins/resize';
import * as echarts from 'echarts';
const colorLost = ['#4FD8FF', '#C15FFF', '#FF5F55', '#FFC935', '#767BFB', 'rgb(248,70,102)'];
export default {
  name: 'lineChart',
  props: {
    chartData: {
      type: Array,
      required: true
    }
  },
  mixins: [resize],
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchart();
    });
  },
  methods: {
    initEchart() {
      let _this = this;
      this.myChart = echarts.init(this.$refs.pieChart);
      this.myChart.setOption({
        color: colorLost,
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return params.marker + ' ' + params.name + '：' + params.value + ' (' + params.percent + '%)';
          }
        },
        legend: {
          show: true,
          left: '15',
          top: 0,
          type: 'scroll',
          itemWidth: 18,
          itemHeight: 11,
          data: this.chartData.map(item => item.name)
        },
        series: [{
          name: _this.$t('消费类型'),
          type: 'pie',
          icon: 'circle',
          radius: ['35%', '55%'],
          center: ['48%', '55%'],
          itemStyle: {
            normal: {
              borderColor: '#fff',
              borderWidth: 1
            }
          },
          data: this.chartData,
          label: {},
          labelLine: {
            normal: {
              show: true
            }
          }
        }]
      }, true);
    }
  },
  watch: {
    chartData: {
      handler(nl, ol) {
        this.initEchart();
      },
      deep: true
    }
  }
};